import {Button, Table, Tooltip} from "antd";
import React from "react";
import {ClickableSpan} from "../../../pools/poolIntensities/responsiveDataTable/ResponsiveDataTable.styles";

const CalculatedTableDetail = ({
    transferReferenceData,
    setMileInformations,
    showModal,
    setSelectedMapData,
    loading
}) => {
    return (
        <>
            <Table dataSource={transferReferenceData || []} loading={loading} scroll={{x: 1000}}>
                <Table.Column
                    title="Yaka"
                    dataIndex="continent"
                    key="continent"
                    render={(continent, record) => <span>{record?.region?.continent || "-"}</span>}
                />
                <Table.Column
                    title="İl"
                    dataIndex="group"
                    key="group"
                    render={(city, record) => <span>{record?.group?.city || "-"}</span>}
                />
                <Table.Column
                    title="İlçe"
                    dataIndex="district"
                    key="district"
                    render={(district, record) => <span>{record?.group?.district || "-"}</span>}
                />
                <Table.Column
                    title="Bölge"
                    dataIndex="region"
                    key="region"
                    render={(region, record) => <span>{record?.region?.name || "-"}</span>}
                />
                <Table.Column
                    title="Teslimat Sayısı"
                    dataIndex="shipmentCount"
                    key="shipmentCount"
                    render={text => <span>{text} Teslimat</span>}
                />
                <Table.Column
                    title="Paket Sayısı"
                    dataIndex="packageCount"
                    key="packageCount"
                    render={text => <span>{text} Paket</span>}
                />
                <Table.Column
                    title="Teslim Alınan Paket Sayısı"
                    key="receivedCount"
                    dataIndex="receivedCount"
                    render={text => <span>{text} Paket</span>}
                />
                <Table.Column
                    title="Kayıp Paket Sayısı"
                    key="missingCount"
                    dataIndex="missingCount"
                    render={text => <span>{text} Paket</span>}
                />
                <Table.Column
                    title="Midmile"
                    dataIndex="midMile"
                    key="midMile"
                    width={"300px"}
                    render={(count, record) => (
                        <div>
                            {record?.courierShipments?.midMile?.length > 0 ? (
                                record?.courierShipments?.midMile?.map(midMileInfo => (
                                    <div
                                        key={midMileInfo?.transferCenter}
                                        style={{display: "flex"}}
                                    >
                                        <Tooltip title={midMileInfo.transferCenterName}>
                                            <span
                                                style={{
                                                    maxWidth: "150px",
                                                    overflow: "hidden",
                                                    textOverflow: "ellipsis",
                                                    whiteSpace: "nowrap"
                                                }}
                                            >
                                                {midMileInfo.transferCenterName}
                                            </span>
                                        </Tooltip>
                                        <ClickableSpan
                                            type="ghost"
                                            onClick={() => {
                                                showModal();
                                                setMileInformations([midMileInfo]);
                                            }}
                                        >
                                            Transferler
                                        </ClickableSpan>
                                    </div>
                                ))
                            ) : (
                                <span>Midmile Seçilmedi</span>
                            )}
                        </div>
                    )}
                />
                <Table.Column
                    title="Lastmile Kurye Tipi"
                    dataIndex="lastMileCouriertype"
                    key="lastMileCouriertype"
                    render={(count, record) => (
                        <span>
                            {record?.courierShipments?.lastMile?.[0]?.type === "car"
                                ? "Araç Kurye"
                                : "Motor Kurye"}{" "}
                            <ClickableSpan
                                type="ghost"
                                onClick={() => {
                                    showModal();
                                    setMileInformations(record?.courierShipments?.lastMile);
                                }}
                            >
                                Transferler
                            </ClickableSpan>
                        </span>
                    )}
                />
                <Table.Column
                    title="Harita"
                    key="map"
                    render={(_, record) => (
                        <Button
                            type="primary"
                            onClick={() => setSelectedMapData(record.encodedPolylines)}
                        >
                            Haritada Göster
                        </Button>
                    )}
                />
            </Table>
        </>
    );
};

export default CalculatedTableDetail;
